<template>
  <div>
    <v-row>
      <v-col
          cols="4"
          class="d-flex align-center justify-center"
      >
        <v-img
            v-if="whale.featurePhoto"
            :src="featurePhotoUrl"
            aspect-ratio="1"
            class="bg-grey-lighten-2 profile-photo"
            cover
        />
        <div
            v-else
            class="no-photo"
        >
          <v-icon size="48">
            mdi-image-off
          </v-icon>
          <div class="text-caption mt-2">
            No profile photo
          </div>
        </div>
      </v-col>
      <v-col cols="8">
        <h3>{{ whale.whaleName }} ({{ whale.whaleId }})</h3>
        <v-text-field
            :model-value="whale.species"
            label="Species"
            readonly
            variant="outlined"
            density="compact"
            hide-details
            class="mt-3"
        />
        <v-text-field
            :model-value="whale.birthYear"
            label="Birth Year"
            readonly
            variant="outlined"
            density="compact"
            hide-details
            class="mt-3"
        />
        <v-text-field
            v-if="whale.mother"
            :model-value="motherDisplay"
            label="Mother"
            readonly
            variant="outlined"
            density="compact"
            hide-details
            class="mt-3"
        />
        <v-text-field
            :model-value="whale.behaviours"
            label="Behaviours"
            readonly
            variant="outlined"
            density="compact"
            hide-details
            class="mt-3"
        />
        <v-text-field
            :model-value="whale.features"
            label="Features"
            readonly
            variant="outlined"
            density="compact"
            hide-details
            class="mt-3"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    whale: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    motherDisplay() {
      if (!this.whale.mother) return "";
      const confidence = this.whale.maternalConfidence;
      return confidence
        ? `${this.whale.mother} (${confidence})`
        : this.whale.mother;
    },
    featurePhotoUrl() {
      if (!this.whale.featurePhoto) {
        return "";
      }
      const url = this.whale.featurePhoto.thumbnailUrl;
      if (!url) return "";
      if (url.startsWith("http")) return url;
      return `${process.env.VUE_APP_API_URL}${url}`;
    },
  },
};
</script>

<style scoped>

.profile-photo {
  width: 100%;
  border-radius: 4px;
}

.no-photo {
  text-align: center;
  color: gray;
}

</style>
